const Chinese = {
  common: {
    'home': '首页',
  },
}

export default Chinese;